import { paddocksByIdsQueryOptions } from '../../../hooks/data/usePaddocks'
import { queryClient } from '../../../queryClient'

export async function getSelectedPaddocks({ values }) {
  if (!values?.length) {
    return []
  }

  const paddocksFromDb = await queryClient.fetchQuery(paddocksByIdsQueryOptions(values))
  return paddocksFromDb
    .map(p => ({ id: p.id, label: p.name }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

export async function getSelectedRodeoPaddocks({ values }) {
  const paddockOutCircuit = { id: 'out-circuit-paddock-id', label: 'Fuera de circuito' }
  const paddocksDivider = { divider: true, label: 'Seleccionados en mapa' }
  const selectedPaddock = await getSelectedPaddocks({ values })

  return [{ ...paddockOutCircuit }, { ...paddocksDivider }, ...selectedPaddock]
}
